import React from 'react';
import { Layout } from 'antd';
import { useCheckDevice, useToggleValue } from '@/hooks';
import { Breadcrumbs } from '../Common';

import { Sidebars } from './Sidebar';

interface IPropsLayoutMain {
  children: React.ReactNode;
}

export const LayoutMain: React.FC<IPropsLayoutMain> = ({ children }) => {
  const { Header, Content } = Layout;
  const { isMobile } = useCheckDevice();
  const collapseStorage = isMobile ? 'false' : window.localStorage.getItem('collapse-menu') ?? 'false';
  const [collapsed, setCollapsed] = useToggleValue(JSON.parse(collapseStorage));
  return (
    <Layout>
      <Sidebars collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <Header className="titan-header">
          <Breadcrumbs />
        </Header>
        <Content className="titan-layout__content">{children}</Content>
      </Layout>
    </Layout>
  );
};
